import script from "./reportGkzw.vue?vue&type=script&setup=true&lang=js"
export * from "./reportGkzw.vue?vue&type=script&setup=true&lang=js"

import "./reportGkzw.vue?vue&type=style&index=0&id=19b0f754&lang=less"

const __exports__ = script;

export default __exports__